import {HOW_IT_WORKS} from '@product/narcis/proposition'

import styles from './PackStepStrip.module.scss'

// The steps are the canon's how-it-works titles: your photos, your model, every pack.
const STEPS = HOW_IT_WORKS.map((step) => step.title.toUpperCase())

/** Step strip, inserted directly after the hero CTA. */
export function PackStepStrip() {
    return (
        <ol className={styles.strip} aria-label="How it works in three steps">
            {STEPS.map((label, i) => (
                <li key={label} className={styles.step}>
                    <b className={styles.stepNum}>{i + 1}</b> {label}
                </li>
            ))}
        </ol>
    )
}
